/*!

=========================================================
* Paper Dashboard React - v1.3.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Licensed under MIT (https://github.com/creativetimofficial/paper-dashboard-react/blob/main/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Container,
  InputGroup,
  InputGroupText,
  InputGroupAddon,
  Input,
} from "reactstrap";

import routes from "routes.js";
import { useHistory } from 'react-router-dom';

let axios = require('axios');
// let Pusher = require('pusher-js');
// let channel6 = null;
let URL_API = "https://xs458763.xsrv.jp/api/";

function Header(props) {
  const [isOpen, setIsOpen] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const [color, setColor] = React.useState("transparent");
  const sidebarToggle = React.useRef();
  const location = useLocation();
  const [msgCnt, setMsgCnt] = React.useState(0);
  const history = useHistory();

  let session = window.sessionStorage.getItem('sessions');
  let se = JSON.parse(session);
  if(!se){
    window.location = '/';
  }

  const toggle = () => {
    if (isOpen) {
      setColor("transparent");
    } else {
      setColor("dark");
    }
    setIsOpen(!isOpen);
  };
  const dropdownToggle = (e) => {
    setDropdownOpen(!dropdownOpen);
  };
  const getBrand = () => {
    let brandName = "編集画面";
    routes.map((prop, key) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        brandName = prop.name;
      }
      return null;
    });
    return brandName;
  };
  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    sidebarToggle.current.classList.toggle("toggled");
  };
  // function that adds color dark/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && isOpen) {
      setColor("dark");
    } else {
      setColor("transparent");
    }
  };

  const onToMessagePage = (e) => {
    if(se['userkind'] == 'coach')
      history.push('/coach/chatMembers');
    else
      history.push('/admin/members');
  }
  React.useEffect(() => {
    // if(channel6){
    //   channel6.unbind();
    //   channel6 = null;
    // }

    // Pusher.logToConsole = true;
    // var pusher = new Pusher('b2abdb42571de8acda20', {
    //     cluster: 'ap3'
    // });
    // // console.log('my-receive-msg-'+se['id']);
    // channel6 = pusher.subscribe('my-'+se['id']);
    // channel6.bind('my-event', function(data) {
    //   // console.log(data);
    //   setMsgCnt(data['data']['cnt']);
    // });
    // window.addEventListener("resize", updateColor.bind(this));
    // axios.get(URL_API+"getMCnt", {
    //   params: {
    //     id : se['id']
    //   }
    // })
    // .then(function (response) {
      
    // }).catch(
    //   error => {
    //     if(error.response){
    //       console.log(error.response.data);
    //     };
    //   }
    // ); 
    window.addEventListener("resize", updateColor.bind(this));
    // return () => {
    //   channel6.unbind();
    // }
  });
  React.useEffect(() => {
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      sidebarToggle.current.classList.toggle("toggled");
    }
  }, [location]);
  return (
    // add or remove classes depending if we are on full-screen-maps page or not
    <Navbar
      color={
        props.location.pathname.indexOf("full-screen-maps") !== -1
          ? "dark"
          : color
      }
      expand="lg"
      className={
        props.location.pathname.indexOf("full-screen-maps") !== -1
          ? "navbar-absolute fixed-top  NavBg "
          : "navbar-absolute fixed-top  NavBg "
      }
    >
      <Container fluid className="d-flex justify-content-between mr-2">
        <div className="navbar-wrapper">          
          <NavbarBrand>{getBrand()}</NavbarBrand>
        </div>
        {/*<div>
                  <i className="fa fa-envelope" aria-hidden="true" style={{color:'#d1d3e2', 'fontSize':'20px'}} onClick={(e) => onToMessagePage(e)}></i>
                  {
                    msgCnt > 0 && (
                      <span className="msgCnt">{msgCnt}</span>)
                  }
                </div>*/}
        
        {/*<Collapse isOpen={isOpen} navbar className="justify-content-end">
                  <form>
                    <InputGroup className="no-border">
                      <Input placeholder="Search..." />
                      <InputGroupAddon addonType="append">
                        <InputGroupText>
                          <i className="nc-icon nc-zoom-split" />
                        </InputGroupText>
                      </InputGroupAddon>
                    </InputGroup>
                  </form>
                  <Nav navbar>
                    <NavItem>
                      <Link to="#pablo" className="nav-link btn-magnify">
                        <i className="nc-icon nc-layout-11" />
                        <p>
                          <span className="d-lg-none d-md-block">Stats</span>
                        </p>
                      </Link>
                    </NavItem>
                    <Dropdown
                      nav
                      isOpen={dropdownOpen}
                      toggle={(e) => dropdownToggle(e)}
                    >
                      <DropdownToggle caret nav>
                        <i className="nc-icon nc-bell-55" />
                        <p>
                          <span className="d-lg-none d-md-block">Some Actions</span>
                        </p>
                      </DropdownToggle>
                      <DropdownMenu right>
                        <DropdownItem tag="a">Action</DropdownItem>
                        <DropdownItem tag="a">Another Action</DropdownItem>
                        <DropdownItem tag="a">Something else here</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                    <NavItem>
                      <Link to="#pablo" className="nav-link btn-rotate">
                        <i className="nc-icon nc-settings-gear-65" />
                        <p>
                          <span className="d-lg-none d-md-block">Account</span>
                        </p>
                      </Link>
                    </NavItem>
                  </Nav>
                </Collapse>*/}
      </Container>
    </Navbar>
  );
}

export default Header;
